<template>
  <div
    :class="['dates-input', {
      'dates-input--relative': isRelative
    }]"
    aria-live="polite"
    v-click-outside="closeMenu"
  >
    <MenuLabel
      :class="['dates-input__menu-label', {
        'dates-input__menu-label--first': isFirst
      }]"
      :label="$t('STAY_DATES_HEADER')"
      :isOpen="isOpen"
      :first="isFirst"
      :value="selectedDates"
      :border="hasBorder"
      :errorMessage="errorMessage"
      :isFormField="isFormField"
      @toggle="handleMenuToggled"
    />
    <component
      :is="isMobile ? 'Drawer' : 'DropdownMenu'"
      :visible="isOpen"
      :fitsContent="fitsContent"
      class="location-input__menu-container"
      :title="$t('STAY_DATES_HEADER')"
      @close="handleMenuToggled"
    >
      <div :class="['dates-input__calendar', {
        'dates-input__calendar--fixed-size': !isRelative
      }]">
        <Calendar
          :maxDate="datepickerEndDate"
          :viewType="calendarType"
          :isRangeSelection="true"
          dateFormat="yyyy-MM-dd"
          @dateSelection="handleDateSelection"
        />
      </div>
      <template v-if="isMobile" #footer>
        <ShButton @click="handleMenuToggled" :fullWidth="true" :disabled="!Boolean(selectedDates)">
          {{ $t('STAY_MODIFY_BOOKING_CONFIRM_CTA') }}
        </ShButton>
      </template>
    </component>
  </div>
</template>

<script>
import { Calendar, DropdownMenu, MenuLabel, Drawer } from '@sohohouse/design-system'
import { decorators } from '@sohohouse/platform-resources'

import { calendarTypes } from '../../menuConfig'

const { shared: { DateTime } } = decorators

export default {
  name: 'BedroomsDatesMenu',

  components: {
    Calendar,
    DropdownMenu,
    MenuLabel,
    Drawer
  },

  props: {
    isOpen: {
      type: Boolean,
      default: false
    },

    isFirst: {
      type: Boolean,
      default: false
    },

    selectedDates: {
      type: String,
      default: ''
    },

    isFormField: {
      type: Boolean,
      default: false
    },

    fitsContent: {
      type: Boolean,
      default: true
    },

    isRelative: {
      type: Boolean,
      default: false
    },

    isStandAlone: {
      type: Boolean,
      default: false
    },

    hasBorder: {
      type: Boolean,
      default: true
    },

    errorMessage: {
      type: String,
      required: false
    }
  },

  computed: {
    calendarType () {
      if (this.isStandAlone) return calendarTypes.tablet

      if (this.$device.isMobile) {
        return calendarTypes.mobile
      }

      if (this.$device.isTablet) {
        return calendarTypes.tablet
      }

      return calendarTypes.desktop
    },

    datepickerEndDate () {
      const date = new DateTime().add(1.5, 'year')
      return date.isoString
    },

    isMobile () {
      return this.$device.isMobile && !this.isFormField
    }
  },


  methods: {
    handleDateSelection (dates) {
      this.$emit('datesSelected', dates)
    },

    handleMenuToggled () {
      this.$emit('menuToggle')
      // Emitting blur to trigger validation on forms
      this.$emit('blur')
    },

    closeMenu () {
      // Help me with a less hacky solution to not pass a handler to vue-click-outside
      // cause this one is disgusting <3
      if (this.isOpen) {
        this.handleMenuToggled()
      }
    }
  }
}
</script>

<style lang="scss" scoped>

$datepicker-tablet-width: 423px; // Doesn't line up at 425px

$datepicker-mobile-max-height: 60vh;
$datepicker-desktop-width: 60vw;
$datepicker-desktop-max-width: 944px;
$datepicker-desktop-padding: 1px;

// Taken from the parent components
$header-height: 75px;
$footer-height: $space-110;

.dates-input {
  &--relative {
    position: relative;
    border-bottom: 1px solid $color_slate_gray;
  }

  &__calendar {
    overflow: scroll;
    max-height: $datepicker-mobile-max-height;

    // Hide scrollbar: Firefox
    scrollbar-width: none;

    &--fixed-size {
      @include tablet {
        width: $datepicker-tablet-width;
      }

      @include desktop {
        width: $datepicker-desktop-width;
      }
    }

    @include tablet {
      position: unset;
      max-height: unset;
    }

    @include desktop {
      position: unset;
      max-width: $datepicker-desktop-max-width;
      padding: 0 $datepicker-desktop-padding;
    }
  }
  // Hide scrollbar: Safari / Chrome
  &__dates-input::-webkit-scrollbar {
    display: none;
  }


  &__menu-label {
    border-top-width: 0;

    &--first {
      border-top-width: 1px;
    }

    @include tablet {
      border-top-width: 1px;
    }
  }
}

</style>
